import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { termsConditionsDialogDefaultOptions } from '../configs/terms-conditions.config';
import { TermsConditionsContainerComponent } from '../containers/terms-conditions-container.component';
import { TermsConditionsDialogOptions } from '@fleet-beat/shared';

@Injectable({
  providedIn: 'root',
})
export class TermsConditionsDialogService {
  constructor(private dialog: MatDialog) {}

  confirm<T>(options?: Partial<TermsConditionsDialogOptions<T>>, width: string = '510px'): Observable<T | boolean> {
    const dialogOption: MatDialogConfig<TermsConditionsDialogOptions<T | boolean>> = {
      width,
      backdropClass: 'terms-backdrop-bg',
      panelClass: 'terms-dialog-container',
      data: { ...termsConditionsDialogDefaultOptions, ...options },
    };

    return this.dialog.open(TermsConditionsContainerComponent, dialogOption).afterClosed();
  }
}
